<template>
  <!-- 有图片的时候显示轮播图 -->
  <div class="swiper-container">
    <!-- <div class="swiper-container" v-if="false"> -->
    <div class="swiper-wrapper" v-if="mediaFiles.length > 0">
      <div class="swiper-slide" v-for="(item, index) in mediaFiles" :key="index" :class="item.fileType">
        <NfVideo v-if="item.videoUrl" :videoUrl="item.videoUrl" :poster="item.coverImgUrl" :ref="`worksDetail_file_item_${index}`">
        </NfVideo>
        <div class="work-img-wrapper" v-else>
          <img v-lazy="item.url" class="work-img" alt="" style="max-width: 100%; max-height: 100%" />
        </div>
      </div>
    </div>
    <div class="gauss-wrapper" v-if="guassPoster">
      <img :src="guassPoster" class="gauss" />
    </div>
    <div class="swiper-wrapper a0" v-if="mediaFiles && mediaFiles.length === 0">
      <div class="swiper-slide">
        <div class="work-img-wrapper">
          <img v-lazy="worksDefaultPic" class="work-img" alt="" style="max-width: 100%; max-height: 100%" />
          <div class="gauss-wrapper">
            <img :src="worksDefaultPic" class="gauss" v-if="worksDefaultPic" />
          </div>
        </div>
      </div>
    </div>
    <!-- 如果需要分页器 -->
    <div class="swiper-pagination swiper-pagination-fraction" v-show="currentFileType !== 'video' && mediaFiles.length > 0"></div>
  </div>
</template>

<script>
import NfVideo from '@/components/NfVideo'
import Swiper from 'swiper'
export default {
  name: 'Banner',
  components: { NfVideo },
  props: {
    mediaFiles: {
      type: Array,
      default: null
    },
    worksDefaultPic: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  computed: {
    currentFileType () {
      const bannerItem = this.mediaFiles[this.activeIndex]
      if (!bannerItem) return ''
      return bannerItem.fileType
    },
    guassPoster () {
      const bannerItem = this.mediaFiles[this.activeIndex]
      if (!bannerItem) return ''
      const isVideo = bannerItem.fileType === 'video'
      return isVideo ? bannerItem.cover : bannerItem.url
    }
  },
  watch: {
    mediaFiles () {
      this.initSwiper()
    }
  },
  mounted () {
    this.initSwiper()
  },
  methods: {
    initSwiper () {
      this.$nextTick(() => {
        const _this = this
        this.oldActiveIndex = 0
        this.swiper = new Swiper('.swiper-container', {
          paginationType: 'fraction',
          // observeParents: true, //修改swiper的父元素时，自动初始化swiper
          pagination: '.swiper-pagination',
          onSlideChangeEnd (swiper) {
            _this.slideChange(swiper.activeIndex)
          }
        })
      })
    },
    slideChange (activeIndex) {
      console.log('slideChange', this.mediaFiles, activeIndex)
      if (activeIndex >= this.mediaFiles.length) return
      const oldFileInfo = this.mediaFiles[this.oldActiveIndex]
      const oldFileIsVideo = oldFileInfo.fileType === 'video'
      if (oldFileIsVideo) {
        const key = `worksDetail_file_item_${this.oldActiveIndex}`
        const videoDom = this.$refs[key][0]
        videoDom && videoDom.handlePause()
      }
      this.oldActiveIndex = activeIndex
      this.activeIndex = activeIndex
    },
    move (offset, direction, speed) {
      // 移动一次的距离， 向左还是向右移动， 图片移动速度
      if (!this.transitionEnd) return
      this.transitionEnd = false
      direction === -1 ? (this.currentIndex += offset / this.imgWidth) : (this.currentIndex -= offset / this.imgWidth)
      if (this.currentIndex > this.sliders.length) this.currentIndex = 1
      if (this.currentIndex < 1) this.currentIndex = this.sliders.length

      const destination = this.distance + offset * direction
      this.animate(destination, direction, speed)
    },
    animate (des, direc, speed) {
      // 实际移动距离 想左还是向右 移动速度 负右正左
      if (this.temp) {
        window.clearInterval(this.temp)
        this.temp = null
      }
      this.temp = window.setInterval(() => {
        if ((direc === -1 && des < this.distance) || (direc === 1 && des > this.distance)) {
          this.distance += speed * direc
        } else {
          this.transitionEnd = true
          window.clearInterval(this.temp)
          this.distance = des
          const allWidth = this.sliders.length * this.imgWidth
          if (des < -allWidth) this.distance = -this.imgWidth
          if (des > -this.imgWidth) this.distance = -allWidth
        }
      }, 10)
    },
    jump (index) {
      const direction = index - this.currentIndex >= 0 ? -1 : 1
      const offset = Math.abs(index - this.currentIndex) * this.imgWidth
      const jumpSpeed = Math.abs(index - this.currentIndex) === 0 ? this.speed : Math.abs(index - this.currentIndex) * this.speed
      this.move(offset, direction, jumpSpeed)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../node_modules/swiper/dist/css/swiper.min.css";
.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-container {
  width: 100%;
  height: 3.8rem;
  background: #eeeeee;
  position: relative;
  .gauss-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    z-index: 1;
    .gauss {
      width: 150%;
      height: 150%;
      object-fit: cover;
      filter: blur(0.7rem);
    }
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 3.8rem;
    z-index: 2;
  }
  .swiper-slide {
    width: 100%;
    height: 3.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    overflow: hidden;
    position: relative;
    z-index: 2;
    &.video {
      border-radius: 0;
    }
    .work-img-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      .work-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        position: relative;
        z-index: 2;
      }
    }
  }
  .swiper-pagination {
    width: 0.88rem;
    font-family: PingFangSC-Regular;
    font-size: 0.24rem;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 0.36rem;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0.2rem;
    right: 0.3rem;
    height: 0.36rem;
    bottom: 0.5rem;
    position: absolute;
    &.video-pagination {
      position: relative;
      left: 0;
      bottom: 0;
    }
  }
  .swiper-pagination-fraction {
    left: 6.3rem;
  }
}
</style>
